import { Tag } from '../Tag';

interface FormLabelProps {
  children: React.ReactNode;
  required?: boolean;
  optional?: boolean;
  className?: string;
  htmlFor?: string;
}

export default function FormLabel({
  children,
  required = false,
  className = '',
  htmlFor,
}: FormLabelProps) {
  return (
    <div className={`flex items-center gap-xs ${className}`}>
      <label className="block text-heading-xxs" htmlFor={htmlFor}>
        {children}
      </label>
      {required && (
        <Tag size={'sm'} color={'danger'} className="font-bold!">
          必須
        </Tag>
      )}
    </div>
  );
}
